import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type SectionHeadingProps = {
  kicker?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  extra?: ReactNode;
};

export default function SectionHeading({
  kicker,
  title,
  description,
  actionLabel,
  actionTo,
  extra,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 flex-wrap mb-5 md:mb-7">
      <div className="max-w-2xl">
        {kicker && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-5 h-[3px] rounded-full bg-primary-500"></span>
            <span className="text-[11px] md:text-xs font-medium tracking-[0.16em] uppercase text-primary-600">
              {kicker}
            </span>
          </div>
        )}
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{description}</p>}
      </div>
      <div className="flex items-center gap-3">
        {extra}
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap group"
          >
            {actionLabel}
            <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
          </Link>
        )}
      </div>
    </div>
  );
}